"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

/**
   * @function DeepClone - 深度拷贝
   * @desc 深度拷贝，防止用其他方法时function等会丢失问题
   * @param {object} obj 需要拷贝的对象
   * @example
   * import { DeepClone } from '@zz-biz/utils';
   * 
   * DeepClone({a: 1});
   * 
   * // return {a: 1}
   */
function deepClone() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var newObj = arguments.length > 1 ? arguments[1] : undefined;

  try {
    newObj = obj instanceof Array ? [] : {};

    for (key in obj) {
      if ((0, _typeof2["default"])(obj[key]) == 'object') {
        newObj[key] = obj[key] instanceof Array ? [] : {};
        newObj[key] = deepClone(obj[key], newObj[key]);
      } else {
        newObj[key] = obj[key];
      }
    }

    return newObj;
  } catch (err) {
    console.warn(err);
    return obj;
  }
}

var _default = deepClone;
exports["default"] = _default;